import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from '../../../../../middlewares/api/actions';
import {FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ} from './actions';
import {getCubesTree} from '../../../../../utils/treeBuilders';
import {
  DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT,
  DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT
} from '../../../../../middlewares/default-category-scheme-selector/actions';
import {getFilteredTreeWithPaths, getMappedTree} from "../../../../../utils/tree";

const fileMappingWizardCubeSelectorReducer = (
  state = {
    categorisedCubes: null,
  },
  action
) => {
  switch (action.type) {
    case REQUEST_START:
      switch (action.label) {
        case FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ:
          return {
            ...state,
            categorisedCubes: null
          };
        default:
          return state;
      }
    case REQUEST_ERROR:
      switch (action.label) {
        case FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ:
          return {
            ...state,
            categorisedCubes: []
          };
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case FILE_MAPPING_WIZARD_CUBE_SELECTOR_CATEGORISED_CUBES_READ:

          let categorisedCubes = getCubesTree(action.response[0], action.response[1]);
          categorisedCubes = getFilteredTreeWithPaths(
            categorisedCubes,
            "children",
            node => node.Code
          );
          categorisedCubes = getMappedTree(
            categorisedCubes,
            "children",
            node => {
              let ordCount = 1;
              return {
                ...node,
                children: node.children
                  ? node.children
                    .sort((a, b) => {
                      if (a.Ord !== undefined && b.Ord !== undefined) {
                        return a.Ord - b.Ord;
                      } else if (a.Ord !== undefined) {
                        return a;
                      } else if (b.Ord !== undefined) {
                        return b;
                      } else {
                        return (a.CatCode || -1) - (b.CatCode || -1);
                      }
                    })
                    .map(c => ({
                      ...c,
                      Ord: c.Ord !== undefined ? String(ordCount++) : undefined
                    }))
                  : node.children
              }
            }
          );

          return {
            ...state,
            categorisedCubes: categorisedCubes
          };
        case DEFAULT_CATEGORY_SCHEME_SELECTOR_SELECT_SUBMIT:
        case DEFAULT_CATEGORY_SCHEME_SELECTOR_CREATE_SUBMIT:
          return {
            ...state,
            categorisedCubes: null
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export default fileMappingWizardCubeSelectorReducer;
